import { Typography } from '@mui/material';

export const projRoleFields = ({ t, userData, roleOptions, projOptions, userProjsRoles, getValues }) => {
  const UserId = userData?.UserId;

  return [
    {
      label: t('SUBCONTRACT_NO'),
      options: projOptions,
      fieldProps: {
        required: !UserId && true
      },
      cProps: {
        rules: {
          validate: (v) => {
            if (!v || v.length === 0) {
              return false;
            }
            if (getValues('UserRole')?.length === 0) {
              return false;
            }

            return true;
          }
        }
      },
      id: 'Project',
      type: 'multiSelect'
    },
    {
      label: t('ROLE'),
      options: roleOptions,
      fieldProps: {
        required: !UserId && true
      },
      cProps: {
        rules: {
          validate: (v) => {
            if (!v || v.length === 0) {
              return false;
            }
            if (getValues('Project')?.length === 0) {
              return false;
            }
            return true;
          }
        }
      },
      id: 'UserRole',
      type: 'multiSelect'
    }
  ];
};
